import React from 'react';
import { useReprocessFile } from './hooks/fileMutations';
import { NotebookFile } from './hooks/useGetAllFiles';
import { SharedIcon } from '../SharedIcon/SharedIcon';

type RAGBadgeProps = {
  file: NotebookFile;
  ownerId: string;
  processingState?: 'processing' | 'stuck';
  readOnly?: boolean;
};

const badgeClasses = 'badge badge--sm text-dark text-xs font-medium ';

const RAGBadge: React.FC<RAGBadgeProps> = ({
  file,
  ownerId,
  processingState,
  readOnly = false,
}) => {
  const reprocessFile = useReprocessFile();

  // File is ready for RAG search
  if (file.rag_ready === true) {
    return (
      <span
        className={badgeClasses + 'bg-success'}
        title="File is ready for search"
      >
        Ready
      </span>
    );
  }

  // File is not ready (either stuck or processing)
  if (file.rag_ready === false) {
    if (processingState === 'stuck') {
      return (
        <span className="d-inline-flex align-items-center">
          <span
            className={badgeClasses + 'bg-warning'}
            title="Processing did not complete. Re-run to make this file searchable."
          >
            Not processing
          </span>
          {!readOnly && (
            <button
              type="button"
              className="button--icon ms-1"
              title="Re-run processing"
              aria-label={`Re-run processing for ${file.file_name}`}
              disabled={reprocessFile.isPending}
              onClick={() =>
                reprocessFile.mutate({
                  fileId: file.id,
                  workspaceId: ownerId,
                })
              }
            >
              <SharedIcon iconName="refresh" size="sm" />
            </button>
          )}
        </span>
      );
    }

    // File is currently processing
    return (
      <span
        className={badgeClasses + 'bg-info'}
        title="File is being processed for search"
      >
        Processing
      </span>
    );
  }

  return null;
};

export default RAGBadge;
